/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Handle, Position } from '@xyflow/react'
import { MdSchema } from 'react-icons/md'
import { Box } from '@chakra-ui/react'
import { useEffect } from 'react'
import { marked } from 'marked'
import hljs from 'highlight.js'

function SchemaValidationNode({ data, isConnectable }) {
  useEffect(() => {
    hljs.highlightAll()
  })

  return (
    <>
      <Box className="custom-node-datahub node-schema">
        <div className="node-header">
          <MdSchema size={20} />
          <span>Schema Validation</span>
        </div>
        <div className="node-content">
          <div className="node-section">
            <div className="node-label">JSON Schema</div>
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
            <div dangerouslySetInnerHTML={{ __html: marked(data?.schema) }} />
          </div>
        </div>
      </Box>
      <Handle id="a" type="source" position={Position.Right} />
      <Handle id="b" type="source" position={Position.Bottom} />
      <Handle type="target" position={Position.Left} />
    </>
  )
}

export default SchemaValidationNode
